import { posthog } from 'posthog-js';

export type FeatureFlags = {
  'expert-activator-type'?: 'single-expert-activator' | 'control';
  'should-hide-widget-lift-test'?: 'hide' | 'control';
} & Record<string, boolean | string | undefined>;

export const getCastedFeatureFlag = <T extends keyof FeatureFlags>(key: T) => {
  return posthog.getFeatureFlag(key) as FeatureFlags[T];
};
